import session from '@/shared/session'

const initialState = () => ({
	patient: {
		prescriptions: [],
	}
})

const state = initialState()

// getters
const getters = {
	getPatientPrescriptions: (state) => () => {
		return state.patient.prescriptions.filter(item => !item.is_chronic)
	},

	getPatientChronicPrescriptions: (state) => () => {
		return state.patient.prescriptions.filter(item => item.is_chronic)
	},
}

// actions
const actions = {
	resetState ({ commit }) {
		commit('reset_state')
	},

	async filterPrescriptionTemplates({ commit, state }, params) {
		const templates = await session
			.get('/api/prescriptions/templates/', {
					params: params
			})

		return templates.data
	},

	createPrescriptionTemplate({ dispatch, commit, rootState }, data) {
		dispatch("loading/load", "prescription-template", { root: true })
		return session
				.post(`/api/prescriptions/templates/`, data)
				.then((template) => {
					dispatch("filterPrescriptionTemplates", {})
					return template.data
				})
	      .finally(() => {
	        dispatch("loading/end", "prescription-template", { root: true })
	      })
	},

	updatePrescriptionTemplate({ commit, dispatch }, { id , data }) {
    dispatch("loading/load", "prescription-template", { root: true })
		return session
			.put(`/api/prescriptions/templates/${id}/`, data)
			.then((template) => {
					return template.data
			})
			.finally(() => {
				dispatch("loading/end", "prescription-template", { root: true })
			})
	},

	deletePrescriptionTemplate({ dispatch }, id) {
		dispatch("loading/load", "prescriptions-template", { root: true })
		return session
			.delete(`/api/prescriptions/templates/${id}/`)
			.then((template) => {
					return template.data
			})
      .finally(() => {
        dispatch("loading/end", "prescriptions-template", { root: true })
      })
	},

	async filterMedication({ commit, state }, params) {
		const items = await session
			.get('/api/catalogue/medications/', {
					params: params
			})

		return items.data
	},

	async getPrescriptionsForCurrentPatient({ commit, dispatch, rootState }) {
		if (!rootState.patients.current) {
			return
		}

		dispatch("loading/load", "prescriptions", { root: true })
		const prescriptions  = await session
			.get(`/api/patients/${rootState.patients.current?.id}/prescriptions/`)

		commit("set_prescriptions", prescriptions.data)

	  dispatch("loading/end", "prescriptions", { root: true })


		return prescriptions.data
	},

	createPrescriptionForCurrentPatient({ commit, rootState, dispatch }, data) {
		dispatch("loading/load", "prescriptions", { root: true })
		return session
				.post(`/api/prescriptions/`, {...data,  decursus: rootState.patients.current?.current_consult?.decursus_id})
				.then(() => {
					return dispatch("getPrescriptionsForCurrentPatient")
				})
	      .finally(() => {
	        dispatch("loading/end", "prescriptions", { root: true })
	      })
	},

	createPatientAdminPrescription({ commit, rootState, dispatch }, data) {
		dispatch("loading/load", "prescriptions", { root: true })
		return session
				.post(`/api/patients/administration/${rootState.patients.current?.id}/prescriptions/`, data)
				.then(() => {
					return dispatch("getPrescriptionsForCurrentPatient")
				})
	      .finally(() => {
	        dispatch("loading/end", "prescriptions", { root: true })
	      })
	},

	createPatientPrescription({ commit, rootState, dispatch }, data) {
		dispatch("loading/load", "prescriptions", { root: true })
		return session
				.post(`/api/prescriptions/`, {...data,  decursus: rootState.decursus.current?.id})
				.then(() => {
					return dispatch("getPrescriptionsForCurrentPatient")
				})
	      .finally(() => {
	        dispatch("loading/end", "prescriptions", { root: true })
	      })
	},
	updatePatientPrescription({ commit, rootState, dispatch }, { id, data }) {
		dispatch("loading/load", "prescriptions", { root: true })
		return session
				.patch(`/api/prescriptions/${id}/`, data)
				.then(() => {
					return dispatch("getPrescriptionsForCurrentPatient")
				})
	      .finally(() => {
	        dispatch("loading/end", "prescriptions", { root: true })
	      })
	},

	deletePatientPrescription({ commit, dispatch }, id) {
		dispatch("loading/load", "prescriptions", { root: true })
		return session
				.delete(`/api/prescriptions/${id}/`)
				.then(() => {
					return dispatch("getPrescriptionsForCurrentPatient")
				})
      .finally(() => {
        dispatch("loading/end", "prescriptions", { root: true })
      })
	},

	prescriptionPrintableById({ commit, state }, { id, data } ) {
		return session
				.get(`/api/prescriptions/${id}/printable/`, {
					params: data,
				})
				.then(printable => {
					return printable.data
				})
	},
}

// mutations
const mutations = {
  reset_state(state) {
		Object.assign(state, initialState())
  },
	
	set_prescriptions(state, prescriptions) {
		state.patient.prescriptions = prescriptions
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}